import React from 'react';
import "../../Assets/CSS/Home.scss";
// import heroDashboard from "../../Assets/Images/Blogs/WhatsApp Image 2025-08-11 at 12.28.01 PM.jpeg";
// import CollegesCarousel from '../../Componants/Carousel/CollegesCarousel';
import TailoredERPSolutions from './TailoredERPSolutions';
import WhyGS from './HowItWorks';
import { Link } from 'react-router-dom';
import Whyglobals from './Whyglobals';
// import Clienttestimonials from './Clienttestimonials';
import Smartercampus from './Smartercampus';
import "../../Assets/CSS/Styles.scss";

const  Homepage = () => {
  const features = [
    {
      title: "10+",
      description: "Years of Experience",

    },
    {
      title: "24hrs",
      description: "Service Support",

    },
    {
      title: "99.9%",
      description: "Uptime Guaranteed",

    },
  ];

  return (
    <>
      {/* Banner Section with Grid */}
      <div className='home_banner mt60  '>
        <div className="home_banner-content grid grid-cols-1 md:grid-cols-2 gap-4 p-4 mt-5 ">
          {/* Column 1 - Could be for text content */}
          <div className="flex flex-col justify-center items-center md:items-start textContent ">
            <h1 className='font-heading font-bold-500 text-white text-2xl md:text-4xl lg:text-5xl text-center md:text-left mb-4'>
              ERP for Education —
              <span className="font-heading font-bold-500 headtext block mt-2 text-2xl md:text-4xl lg:text-5xl" >Cloud-Based, Analytics-Driven</span>
            </h1>
            {/* Optional: Add a button or additional content */}
            <p className='font-ui text-white text-md leading-6 mt-2 p'>
              Automate admissions, attendance & analytics. Streamline your campus operations with our comprehensive ERP solutions designed specifically for educational institutions.
            </p>
            <Link to="/freedemo" className="inline-block">
              <button className="bg-[#F59E0B]  hover:bg-[#f3b541] text-[#0b1120] px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center mt-5 gap-2">
                Book Free Demo
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </Link>
          </div>

          {/* Column 2 - Could be for an image or illustration */}
          {/* <div className="flex justify-center items-center p-4"> */}
            {/* Placeholder for an image - replace with your actual image */}
            {/* <div className="bg-white/20 rounded-lg  flex items-center justify-center text-white"> */}
              {/* [Banner Image] */}
              {/* <img src={heroDashboard} alt="Logo" className="heroDashboard " /> */}
            {/* </div> */}
          {/* </div> */}
        </div>
      </div>
      {/* Additional Grid Sections */}
      <div className="container mx-auto px-4 py-8">
        <h2 className="Headers font-ui">Trusted by Educational Leaders Nationwide</h2>
        <h5 className='subHeads font-ui'>Join hundreds of institutions already transforming their operations</h5>
        {/* Features Grid - responsive columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-10">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center"
            >
              <div className="featureHead font-heading animate-bounceTopToBottom">{feature.title}</div>
              <p className="featureDesc">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* <CollegesCarousel /> */}

      </div>

      {/* new section */}
      <TailoredERPSolutions />
      <WhyGS />


      <Whyglobals />
      {/* <Clienttestimonials /> */}
      <Smartercampus />
    </>
  );
};

export default Homepage;


